(function() {
    // Verificar si ya está inicializado
    if (window.sliderObserverInitialized) return;
    window.sliderObserverInitialized = true;
  
    // Función principal para inicializar un slider
    function initializeSlider(slider) {
      // Verificar si el slider ya fue inicializado
      if (slider.dataset.initialized === 'true') return;
      
      // Esperamos a que los elementos internos estén disponibles
      function tryInitialize() {
        const sliderList = slider.querySelector('.slider');
        const slides = slider.querySelectorAll('.slider__slide');
        const progressBarFill = slider.querySelector('.slider-progress-bar-fill');
  
        if (!sliderList || !slides.length || !progressBarFill) {
          // Si los elementos no están listos, intentamos de nuevo en un momento
          setTimeout(tryInitialize, 100);
          return;
        }
  
        // Marcamos como inicializado
        slider.dataset.initialized = 'true';
  
        const slideWidth = slides[0].offsetWidth;
        const totalSlides = slides.length;
  
        function updateIndicator(index) {
          const sectionWidth = 100 / totalSlides;
          progressBarFill.style.width = `${sectionWidth}%`;
          progressBarFill.style.left = `${sectionWidth * index}%`;
        }
  
        function goToSlide(index) {
          sliderList.scrollTo({
            left: slideWidth * index,
            behavior: 'smooth',
          });
          updateIndicator(index);
        }
  
        // Asegurarnos de que el slideWidth sea correcto
        if (slideWidth === 0) {
          window.addEventListener('resize', () => {
            const newSlideWidth = slides[0].offsetWidth;
            if (newSlideWidth > 0) {
              slideWidth = newSlideWidth;
            }
          });
        }
  
        sliderList.addEventListener('scroll', () => {
          const scrollPosition = sliderList.scrollLeft;
          const currentIndex = Math.round(scrollPosition / slideWidth);
          updateIndicator(currentIndex);
        });
  
        updateIndicator(0);
  
        const prevButton = slider.querySelector('.slider-prev');
        const nextButton = slider.querySelector('.slider-next');
  
        if (prevButton && nextButton) {
          prevButton.addEventListener('click', () => {
            const currentIndex = Math.round(sliderList.scrollLeft / slideWidth);
            const prevIndex = currentIndex <= 0 ? totalSlides - 1 : currentIndex - 1;
            goToSlide(prevIndex);
          });
  
          nextButton.addEventListener('click', () => {
            const currentIndex = Math.round(sliderList.scrollLeft / slideWidth);
            const nextIndex = currentIndex >= totalSlides - 1 ? 0 : currentIndex + 1;
            goToSlide(nextIndex);
          });
        }
      }
  
      // Iniciamos el proceso de inicialización
      tryInitialize();
    }
  
    // Crear el observer principal para nuevos sliders
    const sliderObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        // Verificar nodos añadidos
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Verificar si el nodo es un slider
            if (node.matches('slider-component.slider-card-product')) {
              initializeSlider(node);
            }
            // Verificar si el nodo contiene sliders
            const childSliders = node.querySelectorAll('slider-component.slider-card-product');
            childSliders.forEach(slider => initializeSlider(slider));
          }
        });
      });
    });
  
    // Función de inicialización principal
    function init() {
      // Inicializar sliders existentes
      document.querySelectorAll('slider-component.slider-card-product')
        .forEach(slider => initializeSlider(slider));
  
      // Observar cambios en todo el documento
      sliderObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  
    // Asegurarnos de que el código se ejecute cuando el DOM esté listo
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();